import { BehaviorSubject } from 'rxjs';
import { environment } from '../environment';

export const isProduction$ = new BehaviorSubject<boolean>(
	environment.production,
);
